import { css } from "styled-system/css";
import { Link } from "react-router-dom";

const container = css({
  maxW: "800px",
  mx: "auto",
  px: { base: "5", md: "8" },
});

const h2Style = css({
  fontSize: { base: "lg", md: "xl" },
  fontWeight: "bold",
  color: "#0f172a",
  mt: "10",
  mb: "3",
});

const h3Style = css({
  fontSize: "sm",
  fontWeight: "semibold",
  color: "#0f172a",
  mb: "2",
});

const pStyle = css({
  fontSize: "sm",
  color: "#334155",
  lineHeight: "1.75",
  mb: "4",
});

const ulStyle = css({
  fontSize: "sm",
  color: "#334155",
  lineHeight: "1.75",
  mb: "4",
  pl: "6",
  listStyleType: "disc",
  display: "flex",
  flexDir: "column",
  gap: "1.5",
});

export function PrivacyPolicyPage() {
  return (
    <div className={css({ bg: "#f8fafc", minH: "100vh" })}>
      {/* Barra superior */}
      <div className={css({ bg: "#0B1220", py: "4" })}>
        <div className={container}>
          <Link
            to="/"
            className={css({
              fontSize: "sm",
              fontWeight: "semibold",
              color: "rgba(255,255,255,0.75)",
              textDecoration: "none",
              _hover: { color: "white" },
              display: "inline-flex",
              alignItems: "center",
              gap: "1.5",
            })}
          >
            ← Volver a SFTURNOS
          </Link>
        </div>
      </div>

      {/* Contenido */}
      <div className={container}>
        <div className={css({ py: { base: "10", md: "14" } })}>
          {/* Encabezado */}
          <div className={css({ mb: "10", pb: "8", borderBottomWidth: "1px", borderColor: "#e2e8f0" })}>
            <p className={css({ fontSize: "xs", fontWeight: "semibold", color: "#6366f1", letterSpacing: "0.1em", textTransform: "uppercase", mb: "3" })}>
              Plataforma SFTurnos
            </p>
            <h1 className={css({ fontSize: { base: "2xl", md: "3xl" }, fontWeight: "bold", color: "#0f172a", lineHeight: "1.2", mb: "3" })}>
              Políticas de Privacidad
            </h1>
            <p className={css({ fontSize: "sm", color: "#64748b" })}>
              Última actualización: agosto de 2026
            </p>
          </div>

          {/* Sección 1 */}
          <h2 className={h2Style}>1. Introducción y aceptación</h2>
          <p className={pStyle}>
            SFT Development, CUIT 20-42602561-3, con domicilio en Corrientes, Argentina (en adelante, "la Empresa", "nosotros" o "SFTurnos"),
            es el responsable del tratamiento de los datos personales recolectados a través de la plataforma de gestión de turnos SFTurnos
            (en adelante, "la Plataforma").
          </p>
          <p className={pStyle}>
            La presente Política de Privacidad describe cómo recolectamos, usamos, almacenamos y protegemos los datos personales de los Usuarios,
            en cumplimiento de la Ley N° 25.326 de Protección de los Datos Personales de la República Argentina, su Decreto Reglamentario
            N° 1558/2001 y las disposiciones complementarias dictadas por la Agencia de Acceso a la Información Pública (AAIP).
          </p>
          <p className={pStyle}>
            Al registrarse, utilizar, acceder o navegar la Plataforma, el Usuario manifiesta haber leído, comprendido y aceptado en su totalidad
            esta Política de Privacidad. Si el Usuario no está de acuerdo con alguno de los términos aquí establecidos, deberá abstenerse de
            utilizar la Plataforma.
          </p>

          {/* Sección 2 */}
          <h2 className={h2Style}>2. Definiciones</h2>
          <ul className={ulStyle}>
            <li><strong>Usuario:</strong> toda persona humana que se registre y/o utilice la Plataforma, ya sea como cliente final que reserva turnos o como prestador que ofrece sus servicios a través de la misma.</li>
            <li><strong>Cliente:</strong> Usuario que utiliza la Plataforma para reservar turnos con un Prestador.</li>
            <li><strong>Prestador:</strong> Usuario que ofrece servicios profesionales o comerciales a través de la Plataforma y cuya agenda es gestionada por la misma.</li>
            <li><strong>Datos Personales:</strong> toda información de cualquier tipo referida a personas humanas determinadas o determinables, conforme la definición del art. 2° de la Ley 25.326.</li>
            <li><strong>Datos Sensibles:</strong> datos personales que revelan información sobre salud, vida sexual, origen racial, opiniones políticas, convicciones religiosas u otras categorías especialmente protegidas por la Ley 25.326.</li>
            <li><strong>Plataforma:</strong> el sitio web, aplicación y servicios digitales operados por la Empresa para la gestión de turnos y procesamiento de pagos asociados.</li>
          </ul>

          {/* Sección 3 */}
          <h2 className={h2Style}>3. Datos personales que recolectamos</h2>
          <p className={pStyle}>
            La Empresa recolecta exclusivamente los datos personales estrictamente necesarios para el funcionamiento de la Plataforma.
          </p>

          <p className={h3Style}>3.1. Datos provistos directamente por el Usuario</p>
          <ul className={ulStyle}>
            <li>Nombre y apellido.</li>
            <li>Dirección de correo electrónico.</li>
            <li>Número de teléfono.</li>
            <li>Credenciales de acceso (usuario y contraseña encriptada).</li>
          </ul>

          <p className={h3Style}>3.2. Datos generados por el uso de la Plataforma</p>
          <ul className={ulStyle}>
            <li>Historial de turnos reservados, modificados o cancelados.</li>
            <li>Fecha y hora de inicio de sesión.</li>
            <li>Dirección IP, tipo de dispositivo, navegador y sistema operativo.</li>
          </ul>

          <p className={h3Style}>3.3. Datos de pago y señas</p>
          <p className={pStyle}>
            La Empresa NO recolecta, almacena ni procesa directamente datos de tarjetas de crédito, débito, cuentas bancarias o cualquier otro
            instrumento de pago. Todas las operaciones de pago realizadas a través de la Plataforma son procesadas íntegramente por Mercado Pago
            S.R.L., tercero independiente y responsable autónomo del tratamiento de dichos datos. La Empresa únicamente recibe de Mercado Pago la
            confirmación o rechazo del pago, junto con un identificador de operación, sin acceso a los datos financieros del Usuario.
          </p>
          <p className={pStyle}>
            Cuando el Prestador habilitó el cobro de señas, la Plataforma gestiona el flujo de pago de depósitos previos al turno. Dichos pagos
            están sujetos a la política de cancelación configurada por cada Prestador (ver sección 5).
          </p>

          <p className={h3Style}>3.4. Datos de salud (Odontograma)</p>
          <p className={pStyle}>
            Cuando el Prestador utiliza el módulo de Odontograma, la Plataforma puede almacenar información clínica vinculada al estado dental
            del paciente. Estos datos constituyen <strong>datos sensibles de salud</strong> en los términos del art. 2° de la Ley 25.326 y son
            tratados con las medidas de protección reforzada previstas para dicha categoría. Su carga, consulta y actualización queda bajo la
            exclusiva responsabilidad del Prestador habilitado. El Cliente (paciente) presta su consentimiento expreso para el tratamiento de esta
            información al confirmar un turno con un Prestador que utiliza este módulo.
          </p>

          <p className={h3Style}>3.5. Datos de Google Calendar</p>
          <p className={pStyle}>
            Cuando el Prestador conecta su cuenta de Google Calendar a la Plataforma, SFTurnos accede, con autorización expresa del Usuario
            mediante OAuth 2.0, a los siguientes datos:
          </p>
          <ul className={ulStyle}>
            <li>Listado de agendas (calendarios) vinculadas a la cuenta de Google.</li>
            <li>Eventos existentes en las agendas seleccionadas, a los fines de identificar franjas horarias ocupadas y evitar conflictos de reserva.</li>
          </ul>
          <p className={pStyle}>
            La Plataforma también escribe eventos en el calendario de Google del Prestador cuando se confirma un nuevo turno, y puede actualizar
            o eliminar dichos eventos ante modificaciones o cancelaciones.
          </p>
          <p className={pStyle}>
            Los tokens de autorización de Google son almacenados con cifrado AES-256-GCM. El acceso a Google Calendar puede revocarse en cualquier
            momento desde la configuración de la cuenta de Google del Usuario o desde la sección "Configuración → Google Calendar" de la Plataforma.
          </p>

          {/* Sección 4 */}
          <h2 className={h2Style}>4. Finalidades del tratamiento de los datos</h2>
          <p className={pStyle}>Los datos personales recolectados son tratados con las siguientes finalidades:</p>
          <ul className={ulStyle}>
            <li>Permitir el registro y autenticación del Usuario en la Plataforma.</li>
            <li>Facilitar la gestión, reserva, modificación y cancelación de turnos entre Clientes y Prestadores.</li>
            <li>Enviar notificaciones operativas relacionadas con los turnos (confirmaciones, recordatorios, cambios y recordatorios de pago de seña), a través de correo electrónico y mensajería de WhatsApp.</li>
            <li>Sincronizar eventos con Google Calendar cuando el Prestador habilite dicha integración.</li>
            <li>Procesar, a través de Mercado Pago, los pagos correspondientes a los servicios reservados y señas, y liquidar las comisiones que correspondan a la Empresa.</li>
            <li>Gestionar reembolsos automáticos de señas de acuerdo con la política de cancelación configurada por el Prestador.</li>
            <li>Almacenar información clínica en el módulo de Odontograma cuando el Prestador habilite dicha funcionalidad.</li>
            <li>Brindar soporte técnico y atención al Usuario.</li>
            <li>Cumplir con obligaciones legales, fiscales y regulatorias.</li>
            <li>Detectar y prevenir fraudes, abusos o usos no autorizados de la Plataforma.</li>
            <li>Realizar análisis estadísticos internos en forma agregada y disociada.</li>
          </ul>

          {/* Sección 5 */}
          <h2 className={h2Style}>5. Señas, política de cancelación y reembolsos</h2>
          <p className={pStyle}>
            La Plataforma permite a los Prestadores requerir el pago de una seña o depósito previo al momento de confirmar un turno. El monto de
            la seña y las condiciones de reembolso son determinados exclusivamente por cada Prestador, en ejercicio de su autonomía comercial.
          </p>
          <p className={pStyle}>
            <strong>Política de reembolso:</strong> cada Prestador puede configurar en la Plataforma un plazo mínimo de anticipación para que el
            reembolso sea aplicable (por ejemplo, "reembolsable si se cancela con más de 24 horas de anticipación"). Esta política es visible para
            el Cliente al momento de confirmar el pago de la seña. Si el Prestador no configura una política, el reembolso aplica siempre ante
            cualquier cancelación.
          </p>
          <p className={pStyle}>
            <strong>SFTurnos no determina ni garantiza la política de reembolso de ningún Prestador en particular.</strong> El sistema ejecuta
            automáticamente el reembolso a través de Mercado Pago cuando las condiciones configuradas por el Prestador así lo determinan. En caso
            de que no pueda procesarse automáticamente (por razones técnicas o limitaciones del procesador de pagos), la Plataforma notificará al
            Prestador para que gestione la devolución de forma manual.
          </p>

          {/* Sección 6 */}
          <h2 className={h2Style}>6. Notificaciones por WhatsApp</h2>
          <p className={pStyle}>
            La Plataforma envía notificaciones automáticas a los Clientes mediante mensajería de WhatsApp, a través de un proveedor externo de
            WhatsApp Business API. Estas notificaciones pueden incluir:
          </p>
          <ul className={ulStyle}>
            <li>Confirmación de turno (nombre del paciente, nombre del Prestador, fecha y hora del turno, nombre del servicio).</li>
            <li>Recordatorios previos al turno.</li>
            <li>Aviso de cancelación o modificación.</li>
            <li>Solicitud de pago de seña, incluyendo la política de reembolso vigente.</li>
          </ul>
          <p className={pStyle}>
            El envío de notificaciones por WhatsApp requiere que el Cliente haya proporcionado su número de teléfono y habilitado este canal de
            comunicación. El Prestador puede desactivar el envío de notificaciones WhatsApp desde la configuración de su agenda.
          </p>
          <p className={pStyle}>
            Los datos del Cliente transmitidos al proveedor de WhatsApp Business API son los estrictamente necesarios para la entrega del mensaje
            (número de teléfono y contenido del mensaje). SFTurnos no almacena el historial de conversaciones de WhatsApp en sus propios
            servidores.
          </p>

          {/* Sección 7 */}
          <h2 className={h2Style}>7. Modelo de intermediación, pagos y comisiones</h2>
          <p className={pStyle}>
            El Usuario reconoce y acepta expresamente que SFTurnos es únicamente una plataforma tecnológica de intermediación que facilita el
            contacto entre Clientes y Prestadores y la gestión de turnos entre ellos. La Empresa NO es parte de la relación profesional, comercial
            ni contractual que se establece entre el Cliente y el Prestador.
          </p>
          <p className={pStyle}>
            Por la utilización de la Plataforma y por la intermediación en el cobro de los servicios, la Empresa percibe una comisión sobre los
            pagos procesados. Esta comisión retribuye exclusivamente el uso de la infraestructura tecnológica y los servicios de intermediación, y
            bajo ningún concepto implica que la Empresa asuma responsabilidad sobre la prestación, calidad, idoneidad, oportunidad o resultado del
            servicio brindado por el Prestador al Cliente.
          </p>
          <p className={pStyle}>
            La percepción de una comisión no convierte a la Empresa en proveedora del servicio principal, ni en garante, fiadora, codeudora o
            solidaria responsable de las obligaciones del Prestador frente al Cliente, ni del Cliente frente al Prestador.
          </p>

          {/* Sección 8 */}
          <h2 className={h2Style}>8. Limitación de responsabilidad</h2>
          <p className={pStyle}>
            En los términos de los artículos 1716 y siguientes del Código Civil y Comercial de la Nación, y dentro de los límites permitidos por
            la legislación vigente, SFT Development NO será responsable, en ningún caso, por:
          </p>
          <ul className={ulStyle}>
            <li>La calidad, oportunidad, idoneidad, legalidad, veracidad o cualquier otra característica de los servicios prestados por los Prestadores a los Clientes.</li>
            <li>Los daños, perjuicios, lesiones, pérdidas o cualquier otra consecuencia derivada de la prestación del servicio acordado entre Cliente y Prestador.</li>
            <li>El incumplimiento de turnos por parte del Cliente o del Prestador.</li>
            <li>La exactitud, veracidad o vigencia de la información clínica u otra información publicada por los Prestadores en sus perfiles (servicios, horarios, credenciales profesionales, etc.).</li>
            <li>Las decisiones de Mercado Pago respecto del procesamiento, retención, devolución, reversión o rechazo de pagos, ni por sus comisiones o cargos.</li>
            <li>Las fallas, demoras o indisponibilidad de servicios de terceros (Google Calendar, WhatsApp Business API, Mercado Pago) que impidan el correcto funcionamiento de las integraciones.</li>
            <li>La pérdida de datos, lucro cesante, daño emergente o cualquier otro daño indirecto derivado del uso o imposibilidad de uso de la Plataforma.</li>
            <li>Las interrupciones derivadas de causas ajenas a la Empresa (fuerza mayor, ataques informáticos, fallas de proveedores de servicios, etc.).</li>
          </ul>
          <p className={pStyle}>
            En todo caso, si algún tribunal determinara la existencia de responsabilidad de la Empresa, la misma quedará limitada al monto
            efectivamente percibido por la Empresa en concepto de comisiones por la operación específica que dio origen al reclamo, durante los
            tres (3) meses inmediatamente anteriores al hecho generador.
          </p>

          {/* Sección 9 */}
          <h2 className={h2Style}>9. Plazo de conservación de los datos</h2>
          <p className={pStyle}>
            Los datos personales serán conservados mientras dure la relación entre el Usuario y la Plataforma, y por los plazos adicionales
            necesarios para cumplir con obligaciones legales, fiscales o de defensa en juicio. Los datos sensibles de salud (Odontograma) se
            conservarán de conformidad con la normativa aplicable en materia de historias clínicas. Cumplidos los plazos aplicables, los datos
            serán eliminados o disociados de manera irreversible.
          </p>

          {/* Sección 10 */}
          <h2 className={h2Style}>10. Cesión y transferencia de datos</h2>
          <p className={pStyle}>
            La Empresa podrá compartir los datos personales del Usuario con los siguientes terceros, exclusivamente con las finalidades indicadas:
          </p>
          <ul className={ulStyle}>
            <li><strong>Prestadores:</strong> datos de identificación y contacto del Cliente estrictamente necesarios para la prestación del servicio reservado.</li>
            <li><strong>Mercado Pago S.R.L.:</strong> para el procesamiento de pagos y señas. El tratamiento por parte de Mercado Pago se rige por sus propios términos y políticas de privacidad.</li>
            <li><strong>Google LLC:</strong> cuando el Prestador conecta Google Calendar, ciertos datos del turno (fecha, hora, servicio) son enviados a los servidores de Google para la creación de eventos en el calendario. El tratamiento por parte de Google se rige por su propia Política de Privacidad.</li>
            <li><strong>Proveedor de WhatsApp Business API:</strong> los datos necesarios para la entrega de notificaciones (número de teléfono, contenido del mensaje). El tratamiento se rige por los términos del proveedor y la Política de Privacidad de Meta Platforms, Inc.</li>
            <li><strong>Proveedores de infraestructura tecnológica:</strong> hosting, almacenamiento en la nube, correo electrónico y servicios analíticos, que actúan como encargados de tratamiento bajo instrucciones de la Empresa.</li>
            <li><strong>Autoridades competentes:</strong> cuando exista requerimiento judicial, administrativo o legal.</li>
          </ul>
          <p className={pStyle}>
            La Empresa no comercializa, vende, alquila ni cede los datos personales del Usuario a terceros con fines publicitarios o comerciales
            ajenos a la operación de la Plataforma.
          </p>

          {/* Sección 11 */}
          <h2 className={h2Style}>11. Derechos del titular de los datos</h2>
          <p className={pStyle}>Conforme la Ley 25.326, el Usuario tiene derecho a:</p>
          <ul className={ulStyle}>
            <li><strong>Acceso:</strong> solicitar información sobre sus datos personales en forma gratuita, a intervalos no inferiores a seis (6) meses, salvo acreditación de interés legítimo.</li>
            <li><strong>Rectificación:</strong> solicitar la corrección de datos inexactos, incompletos o desactualizados.</li>
            <li><strong>Supresión:</strong> solicitar la eliminación de sus datos, salvo cuando exista obligación legal de conservación.</li>
            <li><strong>Actualización:</strong> solicitar la actualización de sus datos.</li>
            <li><strong>Oposición:</strong> oponerse al tratamiento de sus datos en los casos previstos por la ley.</li>
          </ul>
          <p className={pStyle}>
            Para ejercer estos derechos, el Usuario podrá enviar una solicitud a{" "}
            <a href="mailto:turnos@sftdevelopment.com" className={css({ color: "#4f46e5", textDecoration: "underline" })}>
              turnos@sftdevelopment.com
            </a>
            , acreditando su identidad. La Empresa responderá dentro de los plazos legales (diez (10) días corridos para acceso y cinco (5) días
            hábiles para rectificación, actualización o supresión).
          </p>
          <p className={pStyle}>
            La Agencia de Acceso a la Información Pública (AAIP) tiene la atribución de atender denuncias y reclamos relacionados con el
            incumplimiento de las normas de protección de datos personales.
          </p>

          {/* Sección 12 */}
          <h2 className={h2Style}>12. Seguridad de la información</h2>
          <p className={pStyle}>
            La Empresa implementa medidas técnicas y organizativas tendientes a proteger los datos personales contra el acceso no autorizado,
            alteración, pérdida o divulgación. Entre dichas medidas se incluyen:
          </p>
          <ul className={ulStyle}>
            <li>Cifrado AES-256-GCM para el almacenamiento de tokens de autorización de servicios de terceros (Google, Mercado Pago).</li>
            <li>Contraseñas de usuario almacenadas con hash criptográfico.</li>
            <li>Validación de firma criptográfica en todos los webhooks recibidos de Mercado Pago.</li>
            <li>Acceso a datos restringido por roles y permisos dentro de la Plataforma.</li>
          </ul>
          <p className={pStyle}>
            No obstante, ningún sistema informático es absolutamente inviolable. La Empresa no garantiza la seguridad absoluta de los datos y no
            será responsable por accesos no autorizados derivados de causas que excedan su diligencia razonable.
          </p>

          {/* Sección 13 */}
          <h2 className={h2Style}>13. Cookies y tecnologías similares</h2>
          <p className={pStyle}>
            La Plataforma utiliza cookies y tecnologías similares para mejorar la experiencia del Usuario, mantener la sesión iniciada y obtener
            estadísticas agregadas de uso. El Usuario puede configurar su navegador para rechazar cookies, debiendo tener presente que ello podría
            limitar el correcto funcionamiento de la Plataforma.
          </p>

          {/* Sección 14 */}
          <h2 className={h2Style}>14. Link de reserva pública</h2>
          <p className={pStyle}>
            Cada agenda cuenta con un link de reserva público que permite a los pacientes solicitar turnos en línea. El Prestador puede desactivar
            este link desde la configuración de su agenda. Cuando el link está desactivado, los visitantes verán únicamente los datos de contacto
            del establecimiento (nombre y teléfono), sin acceso a la disponibilidad ni a los servicios. En ningún caso se exhiben datos personales
            de otros pacientes en el link público.
          </p>

          {/* Sección 15 */}
          <h2 className={h2Style}>15. Menores de edad</h2>
          <p className={pStyle}>
            La Plataforma está dirigida a personas mayores de 18 años. Los menores que la utilicen deberán contar con la autorización expresa de
            sus padres, tutores o representantes legales, quienes serán responsables de las acciones realizadas a través de la cuenta.
          </p>

          {/* Sección 16 */}
          <h2 className={h2Style}>16. Modificaciones a la presente Política</h2>
          <p className={pStyle}>
            La Empresa se reserva el derecho de modificar la presente Política de Privacidad en cualquier momento. Las modificaciones serán
            publicadas en la Plataforma y, en su caso, notificadas al Usuario por los medios de contacto registrados. El uso continuado de la
            Plataforma luego de la publicación implicará la aceptación de las modificaciones.
          </p>

          {/* Sección 17 */}
          <h2 className={h2Style}>17. Ley aplicable y jurisdicción</h2>
          <p className={pStyle}>
            La presente Política de Privacidad se rige por las leyes de la República Argentina. Cualquier controversia derivada de su
            interpretación, cumplimiento o ejecución será sometida a la jurisdicción exclusiva de los Tribunales Ordinarios con competencia en la
            Provincia de Corrientes, República Argentina, renunciando el Usuario a cualquier otro fuero o jurisdicción que pudiera corresponderle.
          </p>

          {/* Sección 18 */}
          <h2 className={h2Style}>18. Contacto</h2>
          <p className={pStyle}>
            Para cualquier consulta, reclamo o ejercicio de derechos relacionados con esta Política de Privacidad:
          </p>
          <div
            className={css({
              p: "5",
              rounded: "xl",
              borderWidth: "1px",
              borderColor: "#e2e8f0",
              bg: "white",
              display: "flex",
              flexDir: "column",
              gap: "2",
              fontSize: "sm",
              color: "#334155",
            })}
          >
            <p className={css({ m: 0 })}>
              <strong>Correo electrónico:</strong>{" "}
              <a href="mailto:turnos@sftdevelopment.com" className={css({ color: "#4f46e5", textDecoration: "underline" })}>
                turnos@sftdevelopment.com
              </a>
            </p>
            <p className={css({ m: 0 })}>
              <strong>Domicilio:</strong> Corrientes, Argentina
            </p>
          </div>

          {/* Footer de la página */}
          <div className={css({ mt: "14", pt: "8", borderTopWidth: "1px", borderColor: "#e2e8f0", display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "4" })}>
            <p className={css({ fontSize: "xs", color: "#94a3b8", m: 0 })}>
              © {new Date().getFullYear()} SFT Development · SFTURNOS · CUIT 20-42602561-3
            </p>
            <Link
              to="/"
              className={css({ fontSize: "xs", color: "#6366f1", textDecoration: "underline", _hover: { opacity: 0.8 } })}
            >
              Volver a la plataforma
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
